module.exports = __webpack_public_path__ + "static/media/entrances.e775efdc.svg";